import * as React from 'react';

import { useRouter } from 'next/router';

import { withExceptionCatcher } from '@/components/hoc/withExceptionCatcher';
import NewsletterDailyPageLayout from '@/components/pages/newsletter/daily/layout/NewsletterDailyPageLayout';
import { IComponent } from '@/types/_app';
import { BlastStruct } from '@/utils/functions/sailthru/fetchSailthruBlasts';
import subscribeToNewsletter, { NewsletterSubscription } from '@/utils/functions/subscribeToNewsletter';

export interface NewsletterDailyPageControllerProps {
    latest: BlastStruct[];
}

export const NewsletterDailyPageController: IComponent<any> = (props: NewsletterDailyPageControllerProps) => {
    const router = useRouter();
    const slug: string = router.query.slug as string;

    switch (slug) {
        case 'research':
            return (
                <NewsletterDailyPageLayout
                    {...props}
                    subscribeCallback={email => subscribeToNewsletter(email, [NewsletterSubscription.ResearchDaily])}
                    frequency="Weekdays"
                    imageUrl="/images/newsletter/Phone_Newsletter.png"
                    title="Blockworks Research Daily"
                    description="Alpha directly in your inbox, including market highlights, charts, degen trade ideas, governance updates, token performance, can’t-miss-tweets and more, by Blockworks Research."
                />
            );
        case 'daily':
        default:
            return (
                <NewsletterDailyPageLayout
                    {...props}
                    subscribeCallback={email =>
                        subscribeToNewsletter(email, [NewsletterSubscription.Daily, NewsletterSubscription.Weekly])
                    }
                    frequency="Weekdays"
                    title="Blockworks Daily"
                    imageUrl="/images/newsletter/Phone_Research.png"
                    description="The newsletter that helps thousands of investors understand crypto and the markets, by Byron Gilliam."
                />
            );
    }
};

export default withExceptionCatcher(NewsletterDailyPageController);
